import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'image-shimmer',
  templateUrl: './image-shimmer.component.html',
  styleUrls: ['./image-shimmer.component.scss']
})
export class ImageShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
